// Home dashboard: a short, constructive legal readiness summary.
// Renders nothing for users without Legal Readiness access.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardCheck } from "lucide-react";

import { lrGet, statusLabel } from "../../lib/clientLegal";

export default function LegalReadinessWidget() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let cancelled = false;
    lrGet("/summary").then((d) => { if (!cancelled) setData(d); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  if (!data) return null;
  const lines = [];
  if (data.critical_blocks > 0) lines.push(`${data.critical_blocks} critical legal block${data.critical_blocks === 1 ? "" : "s"}`);
  if (data.vehicles_blocked > 0) lines.push(`${data.vehicles_blocked} vehicle${data.vehicles_blocked === 1 ? "" : "s"} legally blocked`);
  data.expiring_soon.slice(0, 3).forEach((e) => {
    lines.push(e.days < 0 ? `${e.title} expired` : `${e.title} expires in ${e.days} day${e.days === 1 ? "" : "s"}`);
  });
  if (data.actions_needing_attention > 0) lines.push(`${data.actions_needing_attention} legal action${data.actions_needing_attention === 1 ? "" : "s"} need attention`);
  if (data.missing_facts?.length) lines.push("Legal readiness setup not finished");
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="legal-readiness-widget">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="inline-flex items-center gap-2 font-semibold text-slate-900">
          <ClipboardCheck className="w-4 h-4" /> Legal readiness: {statusLabel(data.business_status)}
        </span>
        <Link to="/app/compliance" className="text-sm underline">Review legal readiness</Link>
      </div>
      {lines.length === 0 ? (
        <p className="mt-1 text-sm text-slate-600">No legal items need attention right now.</p>
      ) : (
        <ul className="mt-2 list-disc pl-5 text-sm text-slate-700">{lines.map((l) => <li key={l}>{l}</li>)}</ul>
      )}
    </div>
  );
}
